import PropTypes from 'prop-types';

import { Box } from '@mui/material';

import { useTransl } from 'shared/lib/i18n';

import CreateMessageContainer from '../containers/CreateMessageContainer';

import SearchComponent from '../../Table/SearchComponent';

import { getSelectValue, isAdmin } from '../../../utils';

import { ActionButton } from '../../Button';
import StyledSelect from '../../Select';

const MessagesHeaderComponent = ({
  hasTwoOrMoreBuildings,
  buildingId,
  selectValue,
  onSelectChange,
  selectOptions,
  openModal,
  closeModal,
  search,
  setSearchValue,
}) => {
  const { t } = useTransl();
  return (
    <Box
      display="flex"
      justifyContent="space-between"
      gap="1rem"
      mt="1rem"
      sx={{ flexWrap: { xs: 'wrap', md: 'nowrap' } }}
    >
      <Box minWidth="30rem" flexGrow={1}>
        <SearchComponent
          value={search ?? ''}
          onChange={setSearchValue}
          fullWidth
        />
      </Box>

      {hasTwoOrMoreBuildings && !buildingId && (
        <Box minWidth="20rem">
          <StyledSelect
            value={getSelectValue(selectValue, selectOptions)}
            onChange={onSelectChange}
            options={selectOptions}
            sortAlphabetically={false}
            disableClearable
          />
        </Box>
      )}

      {!isAdmin() && (
        <ActionButton
          onClick={() =>
            openModal({
              buildingId,
              title: t('actions.chooseRecipients'),
              maxWidth: 'md',
              closeModal,
              render: (props) => <CreateMessageContainer {...props} />,
            })
          }
        >
          {t('actions.createThread')}
        </ActionButton>
      )}
    </Box>
  );
};

MessagesHeaderComponent.defaultProps = {
  search: null,
};

MessagesHeaderComponent.propTypes = {
  hasTwoOrMoreBuildings: PropTypes.bool.isRequired,
  buildingId: PropTypes.number.isRequired,
  selectValue: PropTypes.instanceOf(Object).isRequired,
  onSelectChange: PropTypes.func.isRequired,
  selectOptions: PropTypes.instanceOf(Array).isRequired,
  openModal: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  setSearchValue: PropTypes.func.isRequired,
  search: PropTypes.string,
};

export default MessagesHeaderComponent;
